import * as React from 'react';
import {MessageRoom} from "../../../../../domain/model/message_room";
import {Customer} from "../../../../../domain/model/customer";
import {Project} from "../../../../../domain/model/project";
import {Message} from "../../../../../domain/model/message";
import MessageRoomCard from "../../../../common/organism/card/message_room_card";


interface IProps {
    messageRooms: MessageRoom[];
    customers: Customer[];
    projects: Project[];
    latestMessages: Message[];
    isMessageRooms: boolean;
    initialMessageRoom: MessageRoom | null;
}

export const ClientMessageRoomCards: React.FC<IProps> = (props) => {
    const { messageRooms, customers, projects, latestMessages, initialMessageRoom, isMessageRooms} = props;

    // Customerの連想配列を作成し、MessageRoomから連携させる。
    const hashCustomer: { [customerId: string]: Customer; } = {};
    for (const item of customers) {
        hashCustomer[item.id] = item;
    }

    // Projectの連想配列を作成し、MessageRoomから連携させる。
    const hashProject: { [projectId: string]: Project; } = {};
    for (const item of projects) {
        hashProject[item.id] = item;
    }

    // latestMessageListの連想配列を作成し、MessageRoomから連携させる。
    const hashLatestMessage: { [roomId: string]: Message; } = {};
    for (const item of latestMessages) {
        hashLatestMessage[item.roomID] = item;
    }

    return (
        <React.Fragment>
            {messageRooms.map((messageRoom: MessageRoom) => {
                const roomId: string = messageRoom.projectID + "-" + messageRoom.customerID + "-" + messageRoom.companyID;
                const linkURL: string = `/client/message/${messageRoom.projectID}/${messageRoom.customerID }/${messageRoom.companyID }`;
                const customer: Customer | undefined = hashCustomer[messageRoom.customerID];
                const project: Project | undefined = hashProject[messageRoom.projectID];
                const latestMessage: Message | undefined =hashLatestMessage[roomId];
                if ( !customer || !project ) { return null }
                const customerName: string = customer.getCatchphrase();
                const customerIconURL: string = customer.getIconURL();
                const companyUnRead: boolean = messageRoom.companyUnRead;
                const companyUnReadCount: number | Long = messageRoom.companyUnReadCount;
                const isScout: boolean = messageRoom.isScout;
                const projectId = messageRoom.projectID;
                const opponentId = messageRoom.customerID;
                const initialProjectId = initialMessageRoom ? initialMessageRoom.projectID : "";
                const initialOpponentId = initialMessageRoom ? initialMessageRoom.customerID : "";
                const isInitialMessageRoom = projectId === initialProjectId && opponentId === initialOpponentId;
                const isInitialActive = isMessageRooms && isInitialMessageRoom;

                return (
                    <MessageRoomCard
                        key={roomId}
                        latestMessage={latestMessage}
                        project={project}
                        linkURL={linkURL}
                        opponentAvatarURL={customerIconURL}
                        opponentName={customerName}
                        unRead={companyUnRead}
                        unReadCount={companyUnReadCount}
                        isScout={isScout}
                        isInitialActive={isInitialActive}
                    />
                )
            })}
        </React.Fragment>
    )

};

export default ClientMessageRoomCards;



// WEBPACK FOOTER //
// ./src/presentation/component/client/message_rooms/left/client_message_room_cards.tsx